import { ROUTES } from '@eliadmin/core/src/constants/routes';
import type { AvailableLocales } from '@eliadmin/core/src/stores/locale-store';
import { getDefaultUrlForTosOrGdprLocalized } from '@eliadmin/core/src/utils/misc-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';

type GDPRTextContactFormProps = {
  locale: AvailableLocales;
};

export const GDPRTextContactForm = ({ locale }: GDPRTextContactFormProps) => {
  const GDPRhref = getDefaultUrlForTosOrGdprLocalized(ROUTES?.GDPR?.() ?? '/', locale, 'gdpr');

  const GDPRLink = ({ text, href }: { text: string; href?: string }) => (
    <Link
      href={href ?? GDPRhref}
      className={cn('', 'ea-contact-form__gdpr-link')}
      prefetch={false}
      target="_blank"
    >
      <span className="text-primary">{text}</span>
    </Link>
  );

  switch (locale) {
    case 'sk':
      return (
        <>
          Súhlasím so spracovaním osobných údajov v zmysle <GDPRLink text="GDPR" />
        </>
      );
    case 'cs':
      return (
        <>
          Souhlasím se zpracováním osobních údajů ve smyslu{' '}
          <GDPRLink text="zpracováním osobních údajů" />
        </>
      );
    case 'en':
      return (
        <>
          I agree to the <GDPRLink text="processing of personal data" />
        </>
      );
    case 'de':
      return (
        <>
          Ich stimme zu <GDPRLink text="Verarbeitung personenbezogener Daten" />
        </>
      );
    case 'hu':
      return (
        <>
          Egyetértek <GDPRLink text="személyes adatok kezelése" />
        </>
      );
    case 'pl':
      return (
        <>
          zgadzam się z <GDPRLink text="przetwarzanie danych osobowych" />
        </>
      );
    case 'it':
      return (
        <>
          Sono d&apos;accordo con <GDPRLink text="trattamento dei dati personali" />
        </>
      );
    case 'si':
      return (
        <>
          Strinjam se z <GDPRLink text="obdelava osebnih podatkov" />
        </>
      );
    case 'hr':
      return (
        <>
          slažem se s <GDPRLink text="obrada osobnih podataka" />
        </>
      );
    case 'fr':
      return (
        <>
          Je consens au <GDPRLink text="traitement des données personnelles" />
        </>
      );
    case 'ru':
      return (
        <>
          Я согласен с <GDPRLink text="обработка персональных данных" />
        </>
      );
    case 'ro':
      return (
        <>
          Sunt de acord cu <GDPRLink text="prelucrarea datelor cu caracter personal" />
        </>
      );
    case 'es':
      return (
        <>
          Estoy de acuerdo con <GDPRLink text="tratamiento de datos personales" />
        </>
      );
    case 'fi':
      return (
        <>
          Olen samaa mieltä <GDPRLink text="henkilötietojen käsittely" />
        </>
      );
    case 'se':
      return (
        <>
          Jag håller med <GDPRLink text="behandling av personuppgifter" />
        </>
      );
    default:
      return (
        <>
          I agree to the <GDPRLink text="processing of personal data" />
        </>
      );
  }
};
